import ECheckForm from './ECheckForm';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import {
  checkoutTokenSel,
  expirationDateSel,
  isPendingSel,
  errorSel,
  paySimpleActions as paySimpleCheckoutTokenActions,
  urlDataSel
} from 'src/store/modules/paysimplecheckouttoken';

import { paySimpleActions as paySimplePaymentActions } from 'src/store/modules/paysimplepayment';

import { IEcheckPayment } from 'src/services/paySimple/paySimpleService';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state: IInitialState) => ({
  jwtToken: checkoutTokenSel(state),
  expiration: expirationDateSel(state),
  url: urlDataSel(state),
  isPending: isPendingSel(state),
  error: errorSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getCheckoutToken: () => {
    dispatch(paySimpleCheckoutTokenActions.getCheckoutToken());
  },

  createPayment: (params: IEcheckPayment): any => {
    dispatch(paySimplePaymentActions.createPayment(params));
  }
});

export const pureComponent = ECheckForm;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ECheckForm));
